export enum PermissionAction {
  Own = 'own',
}
